//@flow
import type { StepsT } from "./Types";
import { CATEGORY, CONFIRMATION, CONSUMPTION, LOCATION, PROPERTY, PROVIDER, REGISTRATION } from "./constants";

export const STEPS: StepsT = {
  [LOCATION]: {
    id: LOCATION,
    nextStep: CONSUMPTION,
  },
  [CONSUMPTION]: {
    id: CONSUMPTION,
    nextStep: PROVIDER,
  },
  [PROVIDER]: {
    id: PROVIDER,
    nextStep: REGISTRATION,
  },
  [REGISTRATION]: {
    id: REGISTRATION,
    nextStep: CONFIRMATION,
  },
  [CONFIRMATION]: {
    id: CONFIRMATION,
    nextStep: LOCATION,
  },
};

export const PROPERTY_STEPS: StepsT = {
  [PROPERTY]: {
    id: PROPERTY,
    gtmId: "STEP_1_PROPERTY",
    nextStep: CATEGORY,
  },
  [CATEGORY]: {
    id: CATEGORY,
    gtmId: "STEP_2_CATEGORY",
    nextStep: LOCATION,
  },
  [LOCATION]: {
    id: LOCATION,
    gtmId: "STEP_3_LOCATION",
    nextStep: CONSUMPTION,
  },
  [CONSUMPTION]: {
    id: CONSUMPTION,
    gtmId: "STEP_4_USAGE",
    nextStep: PROVIDER,
  },
  [PROVIDER]: {
    id: PROVIDER,
    gtmId: "STEP_5_TARIFF",
    nextStep: REGISTRATION,
  },
  [REGISTRATION]: {
    id: REGISTRATION,
    nextStep: CONFIRMATION,
  },
  [CONFIRMATION]: {
    id: CONFIRMATION,
    nextStep: LOCATION,
  },
};
